<template>
  <div id="word-cloud" />
</template>

<script>
import wordCloud from 'wordcloud';

export default {
  name: 'WordCloud',
  data () {
    return {
      words: [
        ['多元升学指南', 30],
        ['如何有效进行人际沟通', 14],
        ['PURRRRS练习', 15],
        ['拖延问题的解决', 20],
        ['职业兴趣探索', 16],
        ['如何察觉情绪', 16],
        ['学科效能感', 14],
        ['我的多元能力', 16],
        ['职业价值观', 18],
        ['如何提升时间管理能力', 20],
        ['学习状态的激发', 18],
        ['听听朋友的烦恼', 14],
        ['考试焦虑的表现和成因', 14],
        ['职业统一性', 14],
        ['积极应对生活变化', 14],
        ['优势智能解析', 16],
        ['世界工作地图', 14],
      ],
    }
  },
  mounted () {
    const dom = document.getElementById('word-cloud');

    dom.addEventListener('wordcloudstop', function () {
      setTimeout(function () {
        const els = document.querySelectorAll('.word-item');
        Array.from(els).forEach((el) => {
          el.classList.add("word-animate")
        })
      }, 2000)
    })
    const colorList = [
          '#ca6eff', 
          '#536eff', 
          '#8ffdf1', 
          '#b7ff70', 
          '#ffd47e',  
          '#f88c83',
          '#68a0ff',
          '#000000'
        ]

    wordCloud(dom, {
      list: this.words,
      fontWeight: 'bold',
      classes: 'word-item',
      color: () => {
        return colorList[Math.floor(Math.random() * (colorList.length - 1))]
      }
    })
  },
  methods: {

  },

}
</script>

<style lang="scss">
#word-cloud {
  width: 500px;
  height: 250px;
  .word-animate {
    animation: word 5s infinite ease-in-out alternate;
    // animation-name: word;
    // animation-duration: 10s;
    // animation-iteration-count: infinite;
    // will-change: opacity;
    // opacity: 1;
  }

  .word-animate:nth-child(5n + 1) {
    animation-delay: 0s;
  }
  .word-animate:nth-child(5n + 2) {
    animation-delay: 3s;
  }
  .word-animate:nth-child(5n + 3) {
    animation-delay: 6s;
  }
  .word-animate:nth-child(5n + 4) {
    animation-delay: 9s;
  }
  .word-animate:nth-child(5n + 5) {
    animation-delay: 12s;
  }
}

@keyframes word {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
</style>


